<script>
    export let rates;
	export let tax_year;
    import TaxRow from './TaxRow.svelte';
    import TaxSum from './TaxSum.svelte';
</script>
<table>
    <thead>
        <tr>
            <th scope="col">Tax</th>
            <th scope="col" class="number-column">{tax_year} Rate</th>
            <th scope="col" class="number-column">Amount</th>
        </tr>
    </thead>
    <tfoot>
        <TaxSum mainRates="{rates.main}"></TaxSum>
    </tfoot>
    <tbody>
        {#each Object.entries(rates.main) as [k, rate]}
            <TaxRow tax="{k}" rate="{rate}"></TaxRow>
        {/each}
        {#each Object.entries(rates.optional) as [k, rate]}
            <TaxRow tax="{k}" rate="{rate}" optional></TaxRow>
        {/each}
    </tbody>
</table>
<style>
    table {
        width: 100%;
        margin: .5em 0;
    }
</style>